import { useEffect,useState } from "react";

export const reminderDetail = ({leadID, page, pageSize}) => {
    const [contactData, setContactData] = useState([]);
    const [reminderData, setReminderData] = useState([]);
    const [interactions, setInteractions] = useState([]);
    const [accountOwnsership, setAccountOwnership] = useState([]);
    const [interactionsCount, setInteractionsCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    // const page = 1;
    // const pageSize = 5;

    useEffect(() => {
        const fetchData = async () => {
            try{
                const queryParams = new URLSearchParams({
                    page: page.toString(),
                    page_size: pageSize.toString()
                })
                if (leadID) {
                    queryParams.append("lead_id", leadID.toString());
                    
                    const response = await fetch(
                        `${import.meta.env.VITE_BASE_URL}/lead_reminder?${queryParams.toString()}`,
                    );
                    const result = await response.json();
                    if(response.ok){
                        setContactData(result.contact_data);
                        setAccountOwnership(result.account_ownership);
                        setReminderData(result.reminder_data);
                        setInteractions(result.interactions);
                        setInteractionsCount(result.interactions_count);
                        setTotalPages(result.total_pages);
                        
                    }else{
                        console.error("Failed to fetch lead inventory:", result.error);
                    }
                }else{
                    // console.log("No lead ID provided");
                    return;
                }
            }catch (error){
                console.error("Error fetching data:", error);
                return;
            }
        };
        fetchData();
    }, [leadID, page, pageSize]);

    return {contactData, accountOwnsership, reminderData, interactions, interactionsCount, totalPages};
}